import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export function ProtectedRoute({ children, admin = false }) {
  const { user, checked } = useAuth();
  const location = useLocation();

  if (!checked || user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <div className="flex flex-col items-center gap-4 vp-fade-up">
          <Logo size={32} showText={false} />
          <p className="text-sm text-muted-foreground animate-pulse">Loading your VecPadi…</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/app" replace />;
  if (!admin && !user.onboarded && user.role !== "admin" && location.pathname !== "/onboarding")
    return <Navigate to="/onboarding" replace />;
  return children;
}
